import { cx } from '../../utils';
import styles from './CdIndicatorDot.module.scss';

export interface CdIndicatorDotProps {
  /** Screen-reader text, e.g. "Unread" or "Filter applied". Omit when purely decorative. */
  label?: string;
  tone?: 'danger' | 'brand';
  className?: string;
}

/** Small status dot (unread notification, changed filter group, avatar badge). */
export const CdIndicatorDot = ({ label, tone = 'danger', className }: CdIndicatorDotProps) => {
  return (
    <span
      className={cx(styles.dot, styles[tone], className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
};
